/*
  Bean & Paw size nudge (blocks/bp-size-chart): keeps the "Selected: <size>" line in step with the size pills.
  Read-only: it never touches the product form, the variant id or any button. It reads the checked size input (or
  the selected <option>) of the variant picker and rewrites the line from the block's data-bp-size-template, which
  the server rendered from the locale string. Runs on pill change and after Horizon re-renders the product
  (variant:update), and finds the line again each time because the section may be morphed.
*/
const LINE = '[data-bp-size-option][data-bp-size-template]';

function selectedValue(optionName) {
  // Horizon names each option's radios "<option name>-<block id>-<product id>"; a dropdown uses a <select>
  for (const input of document.querySelectorAll('variant-picker input[type="radio"]:checked')) {
    if (input.name.startsWith(`${optionName}-`)) return input.value;
  }
  for (const select of document.querySelectorAll('variant-picker select')) {
    if (select.name.startsWith(`${optionName}-`) || select.closest('.variant-option')?.querySelector('label, legend')?.textContent.trim() === optionName) {
      return select.selectedOptions[0]?.value;
    }
  }
  return undefined;
}

function sync() {
  for (const line of document.querySelectorAll(LINE)) {
    const value = selectedValue(line.dataset.bpSizeOption);
    if (!value) continue;
    const text = line.dataset.bpSizeTemplate.replace('__SIZE__', value);
    if (line.textContent !== text) line.textContent = text;
  }
}

if (!window.__bpSizeNudge) {
  window.__bpSizeNudge = true;
  document.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) sync();
  });
  document.addEventListener('variant:update', () => requestAnimationFrame(sync));
}
